/* Project Kennel: About pages. Every panel's content is in the HTML; this only switches what is shown. */
(function () {
  if (window.KennelAbout) return; window.KennelAbout = true;
  var $$ = function (r, s) { return [].slice.call(r.querySelectorAll(s)); };

  // Tabs: [data-ka-tabs] root, [data-ka-tab=k] buttons, [data-ka-pane=k] panes, [data-ka-mark=k] highlights.
  function tabs(root) {
    var btns = $$(root, '[data-ka-tab]');
    function show(k) {
      btns.forEach(function (b, i) { var on = b.dataset.kaTab === k; b.setAttribute('aria-pressed', on); if (on) root.style.setProperty('--i', i); });
      $$(root, '[data-ka-pane]').forEach(function (p) { p.hidden = p.dataset.kaPane !== k; });
      $$(root, '[data-ka-mark]').forEach(function (m) { m.classList.toggle('is-on', m.dataset.kaMark === k); });
      root.dataset.active = k;
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { show(b.dataset.kaTab); }); });
    $$(root, '[data-ka-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var i = btns.findIndex(function (x) { return x.dataset.kaTab === root.dataset.active; });
        show(btns[(i + +b.dataset.kaStep + btns.length) % btns.length].dataset.kaTab);
      });
    });
    root.kaShow = show;
    if (btns.length) show(root.dataset.active || btns[0].dataset.kaTab);
  }

  // Flip cards and toggles: any [data-ka-flip] button toggles aria-pressed.
  function flips(root) {
    $$(root, '[data-ka-flip]').forEach(function (b) { b.addEventListener('click', function () { b.setAttribute('aria-pressed', b.getAttribute('aria-pressed') !== 'true'); }); });
  }

  // Extras grid: a row button lights its row and updates the note.
  function grid(root) {
    var note = root.querySelector('[data-ka-hl-note]'), base = note ? note.textContent : '';
    $$(root, '[data-ka-hl]').forEach(function (b) {
      b.addEventListener('click', function () {
        var tr = b.closest('tr'), on = !tr.classList.contains('is-hl');
        $$(root, 'tr.is-hl').forEach(function (x) { x.classList.remove('is-hl'); x.querySelector('[data-ka-hl]').setAttribute('aria-pressed', 'false'); });
        tr.classList.toggle('is-hl', on); b.setAttribute('aria-pressed', on);
        if (note) note.textContent = on ? b.dataset.kaHl : base;
      });
    });
  }

  // Ingredient index filter: chips [data-ka-filter=kind|all-foods], cards [data-kind].
  function filter(root) {
    var chips = $$(root, '[data-ka-filter]'), cards = $$(root, '[data-kind]'), note = root.querySelector('[data-ka-filter-note]');
    function show(f, chip) {
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip); });
      cards.forEach(function (c) { var k = c.dataset.kind; c.hidden = !(f === 'foods' ? /protein|vegetable|fruit/.test(k) : k === f); });
      if (note && chip.dataset.note) note.textContent = chip.dataset.note;
    }
    chips.forEach(function (c) { c.addEventListener('click', function () { show(c.dataset.kaFilter, c); }); });
    if (chips.length) show(chips[0].dataset.kaFilter, chips[0]);
  }

  // Feeding: pet x weight band picks one of the [data-ka-dose="cat-0"] panes.
  function feed(root) {
    var pet = 'cat', band = '0';
    function show() {
      $$(root, '[data-ka-pet]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.kaPet === pet); });
      $$(root, '[data-ka-band]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.kaBand === band); b.textContent = b.dataset[pet]; });
      $$(root, '[data-ka-dose]').forEach(function (p) { p.hidden = p.dataset.kaDose !== pet + '-' + band; });
    }
    $$(root, '[data-ka-pet]').forEach(function (b) { b.addEventListener('click', function () { pet = b.dataset.kaPet; show(); }); });
    $$(root, '[data-ka-band]').forEach(function (b) { b.addEventListener('click', function () { band = b.dataset.kaBand; show(); }); });
    show();
  }

  // Guess the stick: rounds are [data-ka-round] panes; answers carry data-name.
  function guess(root) {
    var rounds = $$(root, '[data-ka-round]'), r = 0, score = 0, played = 0, done = false;
    var res = root.querySelector('[data-ka-res]'), wait = root.querySelector('[data-ka-wait]'), sc = root.querySelector('[data-ka-score]'), num = root.querySelector('[data-ka-num]');
    function show() {
      done = false; root.classList.remove('is-done'); res.hidden = true; wait.hidden = false;
      rounds.forEach(function (p, i) { p.hidden = i !== r; });
      $$(root, '[data-ka-ans]').forEach(function (b) { b.classList.remove('is-right', 'is-pick'); b.setAttribute('aria-pressed', 'false'); });
      num.textContent = r + 1; sc.textContent = score + ' of ' + played;
    }
    $$(root, '[data-ka-ans]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (done) return; done = true; played++;
        var cur = rounds[r], right = cur.dataset.kaRound, ok = b.dataset.kaAns === right; if (ok) score++;
        root.classList.add('is-done'); b.classList.add('is-pick'); b.setAttribute('aria-pressed', 'true');
        $$(root, '[data-ka-ans]').forEach(function (x) { if (x.dataset.kaAns === right) x.classList.add('is-right'); });
        res.querySelector('b').textContent = (ok ? 'Correct. It\'s ' : 'Not quite. It\'s ') + right + '.';
        res.querySelector('b').style.color = ok ? '#2F7D3C' : '#B74558';
        res.querySelector('.ka-hand').textContent = ok ? root.dataset.yes : root.dataset.no;
        var a = res.querySelector('a'); a.href = cur.dataset.url; a.textContent = 'See the ' + right + ' page';
        res.hidden = false; wait.hidden = true; sc.textContent = score + ' of ' + played;
      });
    });
    root.querySelector('[data-ka-nextround]').addEventListener('click', function () { r = (r + 1) % rounds.length; show(); });
    show();
  }

  // Films: [data-ka-film] poster boxes play in place; [data-ka-modal] buttons open a player over the page.
  function films(root) {
    $$(root, '[data-ka-film]').forEach(function (f) {
      var b = f.querySelector('.ka-film__play');
      b.addEventListener('click', function () {
        var v = document.createElement('video'); v.src = f.dataset.kaFilm; v.controls = true; v.playsInline = true; v.setAttribute('aria-label', f.dataset.label || '');
        f.appendChild(v); f.classList.add('is-playing'); v.play();
      });
      $$(f.parentNode, '[data-ka-seek]').forEach(function (s) {
        s.addEventListener('click', function () { if (!f.classList.contains('is-playing')) b.click(); var v = f.querySelector('video'); v.currentTime = +s.dataset.kaSeek; v.play(); });
      });
    });
    $$(root, '[data-ka-modal]').forEach(function (b) {
      b.addEventListener('click', function () {
        var m = document.createElement('div'); m.className = 'ka-modal'; m.setAttribute('role', 'dialog'); m.setAttribute('aria-label', b.dataset.label || 'Film');
        var v = document.createElement('video'); v.src = b.dataset.kaModal; v.controls = true; v.playsInline = true; v.autoplay = true;
        var x = document.createElement('button'); x.type = 'button'; x.setAttribute('aria-label', 'Close'); x.textContent = '×';
        function close() { v.pause(); m.remove(); document.removeEventListener('keydown', esc); b.focus(); }
        function esc(e) { if (e.key === 'Escape') close(); }
        x.addEventListener('click', close); m.addEventListener('click', function (e) { if (e.target === m) close(); }); document.addEventListener('keydown', esc);
        m.appendChild(v); m.appendChild(x); document.body.appendChild(m); x.focus();
      });
    });
  }

  // Factory film: plays muted once on screen; the step tabs follow the film, and tapping a step jumps the film there.
  function factory(root) {
    var v = root.querySelector('[data-ka-fvideo]'), tabsRoot = root.querySelector('[data-ka-tabs]'); if (!v || !tabsRoot) return;
    var btns = $$(tabsRoot, '[data-ka-tab]'), starts = btns.map(function (b) { return +b.dataset.start || 0; });
    var now = root.querySelector('[data-ka-fnow]'), nowN = root.querySelector('[data-ka-fnow-n]'), sound = root.querySelector('[data-ka-fsound]'), soundL = root.querySelector('[data-ka-fsound-label]');
    var still = matchMedia('(prefers-reduced-motion: reduce)').matches, loaded = false, cur = -1, userPaused = false, seen = false;
    function load() { if (loaded) return; loaded = true; v.src = matchMedia('(max-width:749px)').matches ? v.dataset.srcM : v.dataset.src; v.load(); }
    function mark(i) { if (i === cur) return; cur = i; if (tabsRoot.kaShow) tabsRoot.kaShow(btns[i].dataset.kaTab); if (now) now.textContent = btns[i].querySelector('span').textContent.replace(/^\d+/, '').trim(); if (nowN) nowN.textContent = i + 1; }
    v.addEventListener('timeupdate', function () { var t = v.currentTime, i = 0; starts.forEach(function (st, k) { if (t >= st) i = k; }); mark(i); });
    btns.forEach(function (b, i) { b.addEventListener('click', function () { load(); v.currentTime = starts[i]; cur = -1; mark(i); if (!userPaused) v.play().catch(function () {}); }); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { seen = e.isIntersecting; if (e.isIntersecting) { load(); if (!still && !userPaused) v.play().catch(function () {}); } else if (!v.paused && v.muted) v.pause(); }); }, { threshold: .35 }).observe(v);
    } else { load(); seen = true; }
    if (sound) sound.addEventListener('click', function () {
      load();
      if (v.muted) { v.muted = false; v.controls = true; v.play().catch(function () {}); root.classList.add('is-sound'); soundL.textContent = 'Mute'; }
      else { v.muted = true; v.controls = false; if (!seen) v.pause(); root.classList.remove('is-sound'); soundL.textContent = sound.dataset.label || 'Watch with sound'; }
    });
    if (sound) sound.dataset.label = soundL.textContent;
    v.addEventListener('pause', function () { if (v.controls) userPaused = true; });
    v.addEventListener('play', function () { userPaused = false; });
    if (still) { load(); v.controls = true; }
  }

  function init(scope) {
    $$(scope, '[data-ka-tabs]').forEach(function (r) { if (!r.kaT) { r.kaT = 1; tabs(r); } });
    $$(scope, '[data-ka-flips]').forEach(function (r) { if (!r.kaF) { r.kaF = 1; flips(r); } });
    $$(scope, '[data-ka-grid]').forEach(function (r) { if (!r.kaG) { r.kaG = 1; grid(r); } });
    $$(scope, '[data-ka-index]').forEach(function (r) { if (!r.kaI) { r.kaI = 1; filter(r); } });
    $$(scope, '[data-ka-feed]').forEach(function (r) { if (!r.kaD) { r.kaD = 1; feed(r); } });
    $$(scope, '[data-ka-guess]').forEach(function (r) { if (!r.kaQ) { r.kaQ = 1; guess(r); } });
    $$(scope, '[data-ka-films]').forEach(function (r) { if (!r.kaV) { r.kaV = 1; films(r); } });
    $$(scope, '[data-ka-factory]').forEach(function (r) { if (!r.kaX) { r.kaX = 1; factory(r); } });
  }
  function boot() { try { init(document); } catch (e) { if (window.console) console.error('[kennel-about]', e); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { try { init(e.target); } catch (x) {} });
})();
